import {PolicyJsonModel, PolicySchema} from "../../domain/cra/CraDomains";
import ValueFactory from "../../util/ValueFactory";
import {ReduxBaseAction} from "../../domain/redux/ReduxBaseAction";
import {PolicyActions} from "../actions/PolicyActions";
import DeploymentModel from "../../domain/stream/model/DeploymentModel";
import {ComponentDependency} from "../../domain/ui/ComponentMetadata";

export interface PolicyState {
  policy: PolicyJsonModel,
  policySchema: DeploymentModel<PolicySchema> | null,
  isUpdate: boolean,
  dependencies: ComponentDependency[]
  isDirty: boolean
}

const initialState: PolicyState = {
  policy: ValueFactory.initializePolicy(),
  policySchema: {stage: "DRAFT"} as DeploymentModel<PolicySchema>,
  isUpdate: false,
  dependencies: [],
  isDirty: false
}

export const policyReducer = (state = initialState, action: ReduxBaseAction<any, PolicyActions>): PolicyState => {
  switch (action.type) {
    case "CHANGE_POLICY":
      return {...state, policy: action.payload,isDirty: true}
    case "CHANGE_POLICY_SCHEMA":
      return {...state, policySchema: action.payload}
    case "CHANGE_POLICY_IS_UPDATE":
      return {...state, isUpdate: action.payload}
    case "CLEAR_POLICY":
      return {...state, policy: ValueFactory.initializePolicy(), isUpdate: false, policySchema: null, dependencies: [], isDirty: false}
    case "CHANGE_POLICY_DEPENDENCIES":
      return {...state, dependencies: action.payload}
    case "CHANGE_POLICY_DIRTY":
      return {...state, isDirty: action.payload}
    default:
      return state
  }
}
